import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PhoneImage from '../assets/images/phone-img.png'; 

function SeeCanAfford() {
  return (
    <section className="see-can-afford">
      <Container>
        <Row >
          <Col lg={6} className="content-col">
            <div className="content-wrapper">
              <h2>
                See what you can afford <br />
                with Real Estate Home <br />
                Loans
              </h2>
              <p className="subtitle">
                And get personalized tools and recommendations based on a soft view of <br />
                your budget.
              </p>
              <Button className="custom-bttn track-btn">
                Track your liquidity
              </Button>
              <div className="ready-text">
                Ready to get a mortgage? <Link to="/" className="link-text">
                  Explore our options
                </Link>
              </div>
            </div>
          </Col>
          <Col lg={6} className="image-col">
            <div className="phone-mockup">
              <img src={PhoneImage} alt="Phone Mockup" className="img-fluid" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SeeCanAfford;